export function useFormatCode() {
  const formatCode = codes => {
    if (!codes) return '-';
    if (codes.activity?.id && codes.task?.id) return `${codes.activity.id} ${codes.task.id}`;
    if (codes.activity?.id) return codes.activity.id;
    if (codes.task?.id) return codes.task.id;
    if (codes.expense?.id) return codes.expense.id;
    if (codes.id) return codes.id;
    return '-';
  };
  return {
    formatCode
  };
}